<div [@routerTransition]>
    <div class="kt-subheader kt-grid__item">
        <div class="kt-subheader__main">
            <h3 class="kt-subheader__title">
                <span translation="Axilla.Menu.Orders" source="Axilla"></span>
            </h3>
        </div>
    </div>

    <div class="kt-content">
        <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__body">

                <div class="row align-items-center">
                    <div class="col primeng-datatable-container">
                        <p-table #dataTable
                                 styleClass="p-datatable-striped"
                                 (onLazyLoad)="getOrders($event)"
                                 [value]="primengTableHelper.records"
                                 rows="{{primengTableHelper.defaultRecordsCountPerPage}}"
                                 [paginator]="false"
                                 [lazy]="true"
                                 responsiveLayout="stack"
                                 [breakpoint]="'856px'"
                                 selectionMode="single"
                                 (onRowSelect)="openDetails($event)"
                                 [resizableColumns]="primengTableHelper.resizableColumns">

                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 150px" class="text-center">
                                        <span translation='Axilla.OrderSchedule.LastModificationTime'></span>
                                    </th>
                                    <th style="width: 90px" class="text-right">
                                        <span translation='Axilla.OrderSchedule.Quantity'></span>
                                    </th>
                                    <th>
                                        <span translation='Axilla.OrderSchedule.OrderItems'></span>
                                    </th>
                                    <th pSortableColumn="status" style="width: 100px" class="text-left">
                                        <span translation='Axilla.OrderSchedule.Status'></span>
                                        <p-sortIcon field="status"></p-sortIcon>
                                    </th>
                                    <th style="width: 120px" class="text-left">
                                        <span translation='Axilla.OrderSchedule.CreatorUserName'></span>
                                    </th>
                                    <th style="width: 100px" class="text-right">
                                        <span translation='Axilla.OrderSchedule.Total'></span>
                                    </th>

<!--                                    <th style="width: 100px" class="text-center">-->
<!--                                        <span translation='Axilla.OrderSchedule.Actions'></span>-->
<!--                                    </th>-->
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-record="$implicit" let-rowIndex="rowIndex">
                                <tr [pSelectableRow]="record">
                                    <td align="left">
                                        <span class="p-column-title">
                                            <span translation='Axilla.OrderSchedule.LastModificationTime'></span>
                                        </span>
                                        {{record.lastModificationTime | momentFormat:'DD-MM-YYYY, HH:mm'}}
                                    </td>
                                    <td style="text-align: right">
                                        <span class="p-column-title">
                                            <span translation='Axilla.OrderSchedule.Quantity'></span>
                                        </span>
                                        <div>
                                            <div *ngFor="let item of record.orderItems" class="country-item m-b-1">
                                                <div>{{item.quantity}}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td align="left">
                                        <span class="p-column-title">
                                            <span translation='Axilla.OrderSchedule.OrderItems'></span>
                                        </span>
                                        <div>
                                            <div *ngFor="let item of record.orderItems" class="country-item m-b-1">
                                                <div>{{item.article.code}}-{{item.article.title}}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td align="left">
                                        <span class="p-column-title">
                                            <span translation='Axilla.OrderSchedule.Status'></span>
                                        </span>
                                        {{record.state?.name}}
                                    </td>

                                    <td align="left">
                                        <span class="p-column-title">
                                            <span translation='Axilla.OrderSchedule.CreatorUserName'></span>
                                        </span>
                                        {{record.creatorUserName}}
                                    </td>
                                    <td style="text-align: right">
                                        <span class="p-column-title">
                                            <span translation='Axilla.OrderSchedule.Total' source="Axilla"></span>
                                        </span>
                                        {{getTotal(record)}}
                                    </td>
<!--                                    <td>-->
<!--                                        <div class="d-flex justify-content-around align-items-center">-->

<!--                                            <button class="fa-button" (click)="deleteOrder(record.id)">-->
<!--                                                <i class="fa fa-trash"></i>-->
<!--                                            </button>-->
<!--                                        </div>-->
<!--                                    </td>-->
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0 && !primengTableHelper.isLoading">
                            <span translation="Axilla.NoData" source="Axilla"></span>
                        </div>
                        <div class="primeng-no-data" *ngIf="primengTableHelper.isLoading">
                            <span translation="Axilla.LoadingData" source="Axilla"></span>
                        </div>

                        <div class="primeng-paging-container">
                            <p-paginator [rows]="primengTableHelper.defaultRecordsCountPerPage"
                                         #paginator
                                         (onPageChange)="getOrders($event)"
                                         [totalRecords]="primengTableHelper.totalRecordsCount"
                                         [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage">
                            </p-paginator>
                            <span class="total-records-count">
                                {{'TotalRecordsCount' | localize:primengTableHelper.totalRecordsCount}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

